import store from '../store/index'
import Vue from 'vue'
import { router } from "@/router";
import { Toast } from "vant";
import { api_get_goods_by_id, getGoodsStockById } from "@/api/goods-api";
import { GOODS_CATE_INFO, GOODS_TYPE_BOOK, GOODS_TYPE_GENERAL_GOODS } from "@/api/constant";

let vue = new Vue({ router })

/**
 * 购买商品
 * @param {number} goodsId 商品编号
 * @param {number} count 购买数量
 * @param {boolean} addToCart 是否添加到购物车
 * @param {array} spec 已选择商品规格
 * @param {number} price 商品单价
 */
export function mall_util_order_buy_goods(goodsId, count = 1, addToCart = false, spec = [], price = 0, topicId = 0) {
    budo_log.debug("#19 mall_util_order_buy_goods, topicId:", topicId)

    return api_get_goods_by_id(goodsId).then(res => {
        const goodsInfo = res.data;
        if (price === 0) {
            price = goodsInfo.price;
        }

        const jd_supplier_id = 157;
        const vop_supplier_id = 186;
        const add = store.getters.address;

        // 有 地址 或 topicId
        if ((add && add.addressId && add.addressId > 0) || topicId > 0) {
            if (goodsInfo.supplierId === jd_supplier_id) {
                const cartGoodsInfo = store.getters.cart.find(g => g.goods.goodsId === goodsId);
                let quantity = 1;
                if (cartGoodsInfo) {
                    quantity = cartGoodsInfo.count;
                }

                getGoodsStockById(goodsId, quantity, add.addressId).then(res => {
                    budo_log.info('#37 getGoodsStockById', res)
                    if (res.code === 0 && res.data === 1) {
                        createOrder(goodsInfo, goodsId, count, addToCart, spec, price, topicId, add.addressId);
                    } else {
                        Toast.fail({ duration: 3000, message: '商品库存在当前区域不足，无法购买 C' });
                    }
                })
            } else if (goodsInfo.supplierId === vop_supplier_id) {
                const cartGoodsInfo = store.getters.cart.find(g => g.goods.goodsId === goodsId);
                let quantity = 1;
                if (cartGoodsInfo) {
                    quantity = cartGoodsInfo.count;
                }

                createOrder(goodsInfo, goodsId, count, addToCart, spec, price, topicId, add.addressId);
            } else if (goodsInfo.goodsType === 'TICKET') {
                createOrder(goodsInfo, goodsId, count, addToCart, spec, price, topicId, 0);
            } else {
                if (add && add.addressId && add.addressId > 0) {
                    createOrder(goodsInfo, goodsId, count, addToCart, spec, price, topicId, add.addressId);
                } else {
                    Toast.fail({
                        duration: 5000,
                        message: '请点击商品图片设置收货地址 B'
                    });
                }
            }
        } else if (goodsInfo.goodsType !== 'GENERAL_GOODS' && goodsInfo.goodsType !== 'BOOK') {
            // 非 GENERAL_GOODS 且 非 BOOK
            createOrder(goodsInfo, goodsId, count, addToCart, spec, price, topicId, 0);
        } else {
            budo_log.info("#69 mall_util_order_buy_goods, goodsInfo=", goodsInfo, "add=", add)

            Toast.fail({
                duration: 5000,
                message: '请点击商品图片设置收货地址 C'
            });
        }
    });
}

// 加入购物车
function createOrder(goodsInfo, goodsId, count = 1, addToCart = false, spec = [], price = 0, topicId = 0, addressId) {
    budo_log.info("#84 createOrder, goodsInfo=", goodsInfo)

    if ((goodsInfo.goodsType === GOODS_TYPE_GENERAL_GOODS || goodsInfo.goodsType === GOODS_TYPE_BOOK) && addToCart) {
        store.commit('SET_CART', [{
            goods: {
                sn: goodsInfo.sn,
                goodsId,
                name: goodsInfo.name,
                price: price,
                img: goodsInfo.headImage,
                supplierId: goodsInfo.supplierId,
                cateCode: goodsInfo.cateCode,
                cateId: goodsInfo.cateId,
                spec: spec,
                goodsType: goodsInfo.goodsType,
                identityAuth: goodsInfo.identityAuth,
                isPackageGoods: goodsInfo.onlyTimesCard === 1,
                payWxMin: goodsInfo.payWxMin
            },
            checked: true,
            count
        }]);

        Toast.success({ duration: 3000, message: '添加到购物车成功' });

        return 1;
    } else {
        const newOrderInfo = {
            goodsType: goodsInfo.goodsType,
            isPackageGoods: goodsInfo.onlyTimesCard === 1,
            userAddressId: addressId,
            total: price * count,
            cityCode: store.getters.city_code,
            goodsList: [
                {
                    goods: {
                        sn: goodsInfo.sn,
                        goodsId,
                        name: goodsInfo.name,
                        price: price,
                        img: goodsInfo.headImage,
                        cateCode: goodsInfo.cateCode,
                        spec: spec,
                        supplierId: goodsInfo.supplierId,
                        goodsType: goodsInfo.goodsType,
                        identityAuth: goodsInfo.identityAuth,
                        payWxMin: goodsInfo.payWxMin
                    },
                    checked: true,
                    count
                }],
            timeId: new Date().getTime(),
            cateCode: goodsInfo.cateCode,
        }

        store.dispatch('actions_createOrderInfo', newOrderInfo).then(() => {
            budo_log.debug("#131 actions_createOrderInfo /user-center-order-submit", newOrderInfo)

            vue.$router.push({
                path: '/user-center-order-submit', query: {
                    orderMode: '1',
                    cateId: goodsInfo.cateId.toString(),
                    goodsType: goodsInfo.goodsType.toString(),
                    topicId
                }
            });
        })
        return 0;
    }
}


/**
 * 详情商品
 * @param total 总金额
 * @param goodsInfo  {checked,count,goods:{goodsId,name,price,img}}
 * @param isPackageGoods
 */
export function buyDetail(total, goodsInfo, goodsType) {
    const newOrderInfo = {
        goodsType: goodsType,
        userAddressId: 0,
        total: total,
        cityCode: store.getters.city_code,
        goodsList: goodsInfo,
        isPackageGoods: goodsInfo.onlyTimesCard === 1,
        timeId: new Date().getTime()
    }

    store.dispatch('actions_createOrderInfo', newOrderInfo).then(() => { })
}

/**
 * 通过类别id获取类别配置详情
 * @param cateId
 * @returns {{id: number, code: string, adsId: number, addToCart: boolean, requireAddress: boolean}}
 */
export function getCateInfo(cateId) {
    for (const keyName in GOODS_CATE_INFO) {
        const cateInfo = GOODS_CATE_INFO[keyName];
        if (cateInfo.id === cateId) {
            return cateInfo;
        }
    }
}
